import { MakeCall } from 'ha/services/apiV2/createMakeCall';
import { APIV2_URL } from './constants';

export interface Payload {
  password: string;
  password2: string;
  token: string;
}

const resetPassword = (makeCall: MakeCall) => (data: Payload) =>
  makeCall('POST', `${APIV2_URL}/action/reset-password`, { data });

export default resetPassword;
